import { tokens } from 'src/design-system';
import { commonStyles } from "src/Library/CommonStyles";

export const SEFFBidCardStyles = (theme) => ({
  boldPrice: {
    fontSize: '21px',
    color: tokens.colors.textSecondary,
    fontWeight: 'bold',
  },
  cardBodyColumn: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    paddingLeft: 13,
  },
  columnBorderLeft: {
    borderLeft: '1px solid #E9E9E9',
  },
  cardBody: {
    height: 87,
    padding: '14px 8px 14px 14px',
    display: 'flex',
    alignItems: 'center',
  },
  label: {
    fontSize: tokens.fontSize.caption,
    color: tokens.colors.textSecondary,
  },
  value: {
    width: 110,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontSize: tokens.fontSize.body,
    color: tokens.colors.textSecondary,
    fontWeight: tokens.fontWeight.regular,
  },
  cardDiv: {
    height: 108,
    width: '96%',
    marginBottom: tokens.spacing.ms,
    border: '1px solid #E9E9E9',
    borderRadius: tokens.radius.md,
    backgroundColor: tokens.colors.bgWhite,
  },
  bottomContent: {
    color: tokens.colors.textSecondary,
    fontSize: tokens.fontSize.caption,
    ...commonStyles(theme).ellipses,
  },
});
